export const adsHandler = (currentLocale = 'de') => {

  (function (a, d, m, e, i) {
    a.admTagMan = a.admTagMan || {};
    a.admTagMan.q = a.admTagMan.q || [];
    a.admTagMan.cq = a.admTagMan.cq || [];
    a.admTagMan.publisher = d;
    a.admTagMan.lang = m;
    a.admTagMan.version = e;
    a.admTagMan.env = i;

    const el = a.document.createElement('script');
    el.src = '//cdn.admeira.ch/prod/tagmanager/loader.min.js';
    a.document.head.appendChild(el);
  })(window, 'blick.ch', currentLocale.slice(0, 2), 'latest');

// Push commands to loading queue, ads will be loaded asynchronously.
  window.admTagMan.q.push(function () {
    window.admTagMan.init({
      platform: window.innerWidth > 767 ? 'Desktop' : 'MobileWeb',
      //platform: 'Desktop',
      channel: 'Advent',
      targeting: {
        // pagetype: 'overview',
        // admforce: 'qa', // show demo ads
      },
    });
  });

  const slots = [];
  document.querySelectorAll('.box-slot').forEach((slot) => {
    const slotId = slot.getAttribute('id');
    const slotName = slot.getAttribute('data-slot');
    if (slotId && slotName) {
      slots.push({
        id: slotId,
        slot: slotName,
      });
    }
  });

// Define ad tags
  window.admTagMan.q.push(function () {
    if (!slots.length) {
      return;
    }


    slots.map((slot) => {
      window.admTagMan.registerSlot({
        slot: slot.slot,
        container: slot.id,
        events: {
          adLoaded: function(data) {
            document.getElementById(slot.slot).querySelector('.box__title').remove()
            //console.log(`${ slot } - yaaay, ad was loaded`, data);
          },
          adEmpty: function(data) {
            document.getElementById(slot.slot).closest('.box').remove()
            //console.log(`${ slot } - an empty ad was delivered`, data);
          },
        }
      });
    });

    window.admTagMan.loadSlots();
  });
}